import _ from '@/common/helpers';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import FILTER_TYPES from '@/components/query/filter-types';
import SpecResolver from '@/common/spec/spec-resolver';

const {
    method: {enum: apiTrackingMethods},
} = SpecResolver.resolveEntity('ApiTracking');


export default {
    id: 'api-logs',
    version: 1,
    filterSpec: {
        createdTime: {
            type: FILTER_TYPES.datetime,
            options: {
                timePicker: true,
            },
        },
        status: {
            type: FILTER_TYPES.numeric,
        },
        url: {
            type: FILTER_TYPES.text,
        },
        duration: {
            type: FILTER_TYPES.numeric,
        },
        id: {
            type: FILTER_TYPES.text,
        },
        route: {
            type: FILTER_TYPES.text,
        },
        response: {
            type: FILTER_TYPES.text,
        },
        method: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: apiTrackingMethods.sort(),
            },
        },
        request: {
            type: FILTER_TYPES.text,
        },
        'relatedIds.customerId': {
            label: 'Customer Id',
            type: FILTER_TYPES.text,
        },
        'relatedIds.transactionId': {
            label: 'Transaction Id',
            type: FILTER_TYPES.text,
        },
        'relatedIds.tokenId': {
            label: 'Token Id',
            type: FILTER_TYPES.text,
        },
        'requestHeaders.User-Agent': {
            type: FILTER_TYPES.text,
        },
        'requestHeaders.Accept': {
            type: FILTER_TYPES.text,
        },
        'responseHeaders.Rate-Limit-Limit': {
            type: FILTER_TYPES.numeric,
        },
        'responseHeaders.Rate-Limit-Remaining': {
            type: FILTER_TYPES.numeric,
        },
        'responseHeaders.Rate-Limit-Reset': {
            type: FILTER_TYPES.text,
        },
        'user.id': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({id, email}) => `${_.truncate(id, {limit: 11, dots: true})} - ${email}`,
                value: 'id',
            },
        },
        'user.ipAddress': {
            type: FILTER_TYPES.text,
        },
        'user.apiKeyId': {
            type: FILTER_TYPES.text,
        },
        'user.email': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({email}) => email,
                value: 'email',
            },
        },
        'user.firstName': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({firstName}) => firstName,
                value: 'firstName',
            },
        },
        'user.lastName': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({lastName}) => lastName,
                value: 'lastName',
            },
        },
        'user.userAgent': {
            type: FILTER_TYPES.text,
        },
        'user.fingerprint': {
            type: FILTER_TYPES.text,
        },

    },
};
